import { computed, getCurrentInstance, inject } from '@vue/composition-api';
import { MODERN_THEME_KEY } from '@/shells/services/modernThemeController';

export function useChartingLayout() {
  const instance = getCurrentInstance();
  const vm = instance && instance.proxy;
  const modernTheme = inject(MODERN_THEME_KEY, null);
  return {
    isDarkTheme: computed(() => modernTheme
      ? modernTheme.effectiveTheme === 'dark'
      : Boolean(vm && vm.$store && vm.$store.state.dark_theme))
  };
}
